import { SelectItemProps } from 'Components/Form/Select'
import ID_COMPONENTE from 'config/idComponente'
import { Veiculo } from 'Models/cadastros'
import { ParamsRequest } from 'Services/__shared/types/resquest'
import WsCadastroService from 'Services/WS_CADASTRO'
import IFormVeiculosFilter from 'Views/Cadastros/Veiculos/IFormVeiculosFilter'
import { DocasContextValue } from 'Views/Docas/Context/ContextType'

const Veiculos = {
  get: async (forcarAtualizacao = false): Promise<Veiculo[]> => {
    if (!forcarAtualizacao) {
      const veiculos = window.sessionStorage.getItem('veiculos')

      if (veiculos) {
        return JSON.parse(veiculos)
      }
    }

    const filtros: IFormVeiculosFilter = {
      situacao: 'ativo',
    }

    const parametros: ParamsRequest = {
      pageSize: 10000,
      pageNumber: 1,
    }

    const { data } = await WsCadastroService.veiculos.getList(
      ID_COMPONENTE.DOCAS,
      filtros,
      parametros,
    )

    if (data.items) {
      window.sessionStorage.setItem('veiculos', JSON.stringify(data.items))

      return data.items
    } else {
      return []
    }
  },

  getListaSelecao: async (
    docasContext: DocasContextValue,
    setDocasContext: (value: DocasContextValue) => void,
    veiculos?: Veiculo[],
    listaPorCdVeiculo?: boolean,
  ): Promise<SelectItemProps[]> => {
    const veiculosAux: Veiculo[] = veiculos ? veiculos : await Veiculos.get()

    return veiculosAux
      ? veiculosAux.map((item: Veiculo) => {
          return {
            value: listaPorCdVeiculo ? item.id.toString() : item.placa,
            label: item.placa,
          }
        })
      : []
  },
}

export default Veiculos
